var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget-chart"},[(_vm.chartOptions != null)?_c('vue-highcharts',{key:_vm.renderCounter,ref:"chart",attrs:{"options":_vm.chartOptions,"up":""}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }